import React, { useContext } from 'react';
import type { PropsWithChildren } from 'react';
import { DEFAULT_CURRENCY } from '../constants';

export const CurrencyContext = React.createContext<string>(DEFAULT_CURRENCY);

type Props = PropsWithChildren<{
    currency: string;
}>;
export const CurrencyProvider: React.FC<Props> = ({ currency, children }) => (
    <CurrencyContext.Provider value={currency}>{children}</CurrencyContext.Provider>
);

export const useCurrency = (): string => useContext(CurrencyContext);
